import { render, staticRenderFns } from "./Meetings.vue?vue&type=template&id=96f5c844&"
import script from "./Meetings.vue?vue&type=script&lang=js&"
export * from "./Meetings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports